import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

export default function ProjectSideBar({ page }) {
  const history = useHistory();
  const getUserInfo = useSelector((state) => state.getUserInfo);

  return (
    <div className="col-sm-12" style={{ marginTop: "5px" }}>
      <table className="table table-bordered shadow-sm">
        <tbody style={{ position: "sticky", top: "0" }}>
          <tr>
            {getUserInfo.Rol.includes("12") ? (
              <td id="1" style={page === "1" ? styles.selectedTr : styles.defaultTr} onClick={() => history.push("/dashboard/projeistatislik")}>
                İstatistik
              </td>
            ) : null}

            {getUserInfo.Rol.includes("12") ? (
              <td id="5" style={page === "5" ? styles.selectedTr : styles.defaultTr} onClick={() => history.push("/dashboard/hizliTaramaOzet")}>
                Hızlı Tarama Özet
              </td>
            ) : null}
            {getUserInfo.Rol.includes("11") || getUserInfo.Rol.includes("14") ? (
              <>
                <td id="2" style={page === "2" ? styles.selectedTr : styles.defaultTr} onClick={() => history.push("/dashboard/projectArea/" + 1)}>
                  Bölgeler
                </td>
                {getUserInfo.Rol.includes("11") ? (
                  <>
                    <td id="3" style={page === "3" ? styles.selectedTr : styles.defaultTr} onClick={() => history.push("/dashboard/project/" + 1)}>
                      Kişiye Görev Ata
                    </td>
                  </>
                ) : null}
                {getUserInfo.Rol.includes("13") ? (
                  <td id="4" style={page === "4" ? styles.selectedTr : styles.defaultTr} onClick={() => history.push("/dashboard/projectBolgesiOlmayan/" + 1)}>
                    Bölgesi Olmayan Binalar
                  </td>
                ) : null}
              </>
            ) : null}
          </tr>
        </tbody>
      </table>
    </div>
  );
}

const styles = {
  selectedTr: {
    backgroundColor: "#0047ab",
    color: "white",
    cursor: "pointer",
  },
  defaultTr: {
    backgroundColor: "white",
    color: "black",
    cursor: "pointer",
  },
};
